import { z } from 'zod';
export const memberGroupSchema = z.object({
    id: z.string(),
    name: z.string(),
    provider: z.string(),
});
export const memberGroupsSchema = z.array(memberGroupSchema);
